import PropTypes from "prop-types";
import ProductDiscount from "../../ProductDiscount";
import ProductSponsored from "../../ProductSponsored";
import SellingFastBadge from "../../SellingFastBadge";
import styles from "./index.css";

const Banners = ({ discount, isSponsored, isSellingFast }) => (
  <>
    {discount !== null && (
      <ProductDiscount discount={discount} className={styles.productDiscount} />
    )}
    {isSponsored && <ProductSponsored className={styles.productSponsored} />}
    {isSellingFast && <SellingFastBadge className={styles.sellingFastBadge} />}
  </>
);

Banners.propTypes = {
  discount: PropTypes.number,
  isSponsored: PropTypes.bool.isRequired,
  isSellingFast: PropTypes.bool.isRequired
};

export default Banners;
